import { UserLight } from "./User";

export interface Role { 
    id?: string;
    name: string;
    permissions: Permission[];
    users: UserLight[];
    enabled: boolean;
}

export function createRole(permissions: Permission[]): Role {
    return {
        id: undefined,
        name: '',
        permissions: permissions,
        users: [],
        enabled: true
    };
}

export interface RoleLight {
    id: string;
    name: string;
}

export interface Permission {
    id: string;
    name: string;
    access: number;
    // Optional grouping (managed in the DB). Null/absent => ungrouped ("Other").
    categoryId?: string | null;
    categoryName?: string | null;
    categorySortOrder: number;
}